/*( document ).ready(function() {
setInterval(function() {
jQuery.getJSON('/cart.js', function(cart) {
let cartData = cart.item_count;
$(".cart-count-bubble span").text(cartData);
   $('#CartDrawer').load(location.href + " #CartDrawer");
});
}, 400);

$(".product-form__buttons .product-form__submit ").click(function(){
setTimeout(function () {
$('#CartDrawer').load(location.href + " #CartDrawer");
 $("a#cart-icon-bubble span.visually-hidden").trigger("click");
}, 400);
})
  })*/




$('.brand-slider').slick({
  dots: false,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 2000,
  slidesToShow: 5,
  slidesToScroll: 1,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1 
      }
    }
  ]
});

$('.text-slider').slick({
  dots: false,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 3000,
  slidesToShow: 3,
  slidesToScroll: 1,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1 
      }
    }
  ]
});


$('.prod-detail-slider, .testimonials-slider').slick({
  dots: false,
  arrows: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 4000, 
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  cssEase: 'ease-in-out'
});



var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// fade in grid items  ==================================

  // $(document).on("scroll", function () {
  //   var pageTop = $(document).scrollTop()
  //   var pageBottom = pageTop + $(window).height()
  //   var tags = $(".fadein")

  //   for (var i = 0; i < tags.length; i++) {
  //     var tag = tags[i]

  //     if ($(tag).offset().top < pageBottom) {
  //       $(tag).addClass("visible")
  //     } else {
  //       $(tag).removeClass("visible")
  //     }
  //   }
  // })



	$.fn.jQuerySimpleCounter = function( options ) {
	    var settings = $.extend({
	        start:  0,
	        end:    100,
	        easing: 'swing',
	        duration: 400,
	        complete: ''
	    }, options );

	    var thisElement = $(this);

	    $({count: settings.start}).animate({count: settings.end}, {
			duration: settings.duration,
			easing: settings.easing,
			step: function() {
				var mathCount = Math.ceil(this.count);
				thisElement.text(mathCount);
			},
			complete: settings.complete
		});
	};

 $(window).scroll(function() {
              var extraInfoOffset = $('.product-form-main').offset().top;
              var scrollTop = $(window).scrollTop();

              // Adjust this value if needed to set when to toggle the class
              var triggerOffset = extraInfoOffset - 100;

              if (scrollTop > triggerOffset) {
                  $('.sticky-atc-qty').addClass('Sticky_Add-to-cart_button');
              } else {
                  $('.sticky-atc-qty').removeClass('Sticky_Add-to-cart_button');
              }
          });


$(document).ready(function() {
    // Function to update the cart count bubble
    function updateCartCount() {
        jQuery.getJSON('/cart.js', function(cart) {
            let cartData = cart.item_count;
            $(".cart-count-bubble span").text(cartData);
        });
    }

    // Handle the "Add to Cart" button click
    $(".product-form__buttons .product-form__submit").click(function(e) {
        e.preventDefault(); 

        let form = $(this).closest('form'); 

        $.ajax({
            type: form.attr('method'),
            url: form.attr('action'),
            data: form.serialize(),
            dataType: 'json',
            success: function() {
                updateCartCount();
                $("cart-drawer").removeClass("is-empty");
                $('#CartDrawer').load(location.href + " #CartDrawer>*", function() {
                    $("a#cart-icon-bubble span.visually-hidden").trigger("click");
                  
                });
            }
        });
    });

    updateCartCount();
});



$('.landing-new-slider ul').slick({
  dots: false,
  arrows: true,
  infinite: true,
  slidesToShow: 8,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1 
      }
    }
  ]
});

